import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { writeFetch } from '../../api';

const { FiTarget, FiCalendar, FiArrowRight, FiStar } = FiIcons;

const TABLE = 'donation_campaigns_1776500000';

const FeaturedCampaignsWidget = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await writeFetch(`read/${TABLE}?is_featured=1&status=active&limit=3&sort=raised_amount&order=desc`);
        const data = await res.json();
        setCampaigns(Array.isArray(data.data) ? data.data : []);
      } catch { /* silent */ }
      setLoading(false);
    };
    load();
  }, []);

  if (!loading && campaigns.length === 0) return null;

  return (
    <div className="bg-white rounded-[32px] border border-accent-gold/30 p-6 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-accent-gold/10 rounded-xl flex items-center justify-center text-accent-gold">
          <SafeIcon icon={FiStar} className="w-5 h-5" />
        </div>
        <h3 className="font-serif text-xl text-accent-navy">Featured Causes</h3>
      </div>

      {loading ? (
        <div className="space-y-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-24 bg-brand-light rounded-2xl animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="space-y-4">
          {campaigns.map(c => {
            const goal = Number(c.goal_amount) || 0;
            const raised = Number(c.raised_amount) || 0;
            const pct = goal > 0 ? Math.min(Math.round((raised / goal) * 100), 100) : 0;
            const daysLeft = c.deadline
              ? Math.max(0, Math.ceil((new Date(c.deadline) - new Date()) / 86400000))
              : null;

            return (
              <Link key={c.id} to={`/memorial/${c.memorial_id}`} className="block group">
                <div className="p-4 rounded-2xl border border-brand-dark bg-brand-light/30 hover:border-accent-gold transition-colors">
                  <p className="text-[10px] font-black uppercase tracking-widest text-accent-gold mb-1 truncate">
                    {c.beneficiary_name || 'Charity'}
                  </p>
                  <h4 className="text-sm font-bold text-accent-navy line-clamp-1 mb-3 group-hover:text-accent-gold transition-colors">
                    {c.title}
                  </h4>
                  
                  <div className="h-2 bg-brand-dark/20 rounded-full overflow-hidden mb-3">
                    <div className="h-full bg-accent-gold rounded-full" style={{ width: `${pct}%` }} />
                  </div>
                  
                  <div className="flex items-center justify-between text-[9px] font-black uppercase tracking-widest text-text-muted">
                    <span className="flex items-center gap-1.5">
                      <SafeIcon icon={FiTarget} className="w-3 h-3" /> ${raised.toLocaleString()} / ${goal.toLocaleString()}
                    </span>
                    {daysLeft !== null && (
                      <span className="flex items-center gap-1.5 text-accent-navy">
                        <SafeIcon icon={FiCalendar} className="w-3 h-3" /> {daysLeft}d left
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
      
      {!loading && campaigns.length > 0 && (
        <div className="mt-5 pt-4 border-t border-brand-light text-center">
          <Link to="/explore" className="text-[10px] font-black uppercase tracking-widest text-text-muted hover:text-accent-gold transition-colors flex justify-center items-center gap-1.5 group">
            Discover more causes <SafeIcon icon={FiArrowRight} className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      )}
    </div>
  );
};

export default FeaturedCampaignsWidget;